import {
  BULK_BENEFICIARIES_TABLE_HEADERS,
  SINGLE_BENEFICIARIES_TABLE_HEADERS
} from './beneficiaries';
import { FEATURE_FLAG_OVERRIDES_TABLE_HEADERS, FEATURE_FLAGS_TABLE_HEADERS } from './feature-flags';
import { ADMIN_DISPUTES_TABLE_HEADERS, DISPUTES_TABLE_HEADERS } from './disputes';
import { FEES_HEADERS } from './fees';
import { KYC_TABLE_HEADERS } from './kyc';
import { PAYMENT_LINKS_TABLE_HEADERS } from './payment-links';
import { PAYOUTS_TABLE_HEADERS } from './payout';
import { ADMIN_SETTLEMENTS_TABLE_HEADERS, SETTLEMENTS_TABLE_HEADERS } from './settlements';
import { TEAM_HEADERS } from './team';
import { ADMIN_TRANSACTION_TABLE_HEADERS, TRANSACTION_TABLE_HEADERS } from './transactions';
import { WALLET_CONVERSIONS_TABLE_HEADERS } from './wallet-conversions';

const HEADERS = {
  settlements: SETTLEMENTS_TABLE_HEADERS,
  admin_settlements: ADMIN_SETTLEMENTS_TABLE_HEADERS,
  transactions: TRANSACTION_TABLE_HEADERS,
  admin_transactions: ADMIN_TRANSACTION_TABLE_HEADERS,
  payment_links: PAYMENT_LINKS_TABLE_HEADERS,
  disputes: DISPUTES_TABLE_HEADERS,
  payout: PAYOUTS_TABLE_HEADERS,
  single_beneficiaries: SINGLE_BENEFICIARIES_TABLE_HEADERS,
  bulk_beneficiaries: BULK_BENEFICIARIES_TABLE_HEADERS,
  admin_disputes: ADMIN_DISPUTES_TABLE_HEADERS,
  fees: FEES_HEADERS,
  teams: TEAM_HEADERS,
  kyc: KYC_TABLE_HEADERS,
  wallet_conversions: WALLET_CONVERSIONS_TABLE_HEADERS,
  feature_flags: FEATURE_FLAGS_TABLE_HEADERS,
  feature_flag_overrides: FEATURE_FLAG_OVERRIDES_TABLE_HEADERS
};

export { HEADERS };
